import { ButtonOverlay, CustomTable, formatCurrency, numberFilterTemplate, stringFilterTemplate, TableButton } from 'medere-ui-framework'
import { Column } from 'primereact/column'
import { MultiSelect } from 'primereact/multiselect'
import { useEffect, useState } from 'react'
import { AdministrativeFormStateTypeI18n } from '../interface/interface'
import { useSupplierService } from '../servicesHooks/Supplier/useSupplierService'

export interface Movement {
    administrativeform: number
    invoicebusinessname: string
    description: string
    formnumber: number
    date: string
    document: string
    pendingamount: number
    balance: number
    total: number
}

function Movements() {
    const { getMovements, getMovementStatus } = useSupplierService();
    const [movementStatus, setMovementStatus] = useState<AdministrativeFormStateTypeI18n[]>([])
    const [selectedMovementStatus, setSelectedMovementStatus] = useState<AdministrativeFormStateTypeI18n[]>([])
    useEffect(() => {
        getMovementStatus({ filterValue: '', })
            .then((response) => {
                setMovementStatus(response)
            })
    }, [])

    return (
        <div className='mx-3 pt-4 h-screen flex flex-column gap-3'>
            <h1 className='title text-3xl font-semibold'>Proveedores / Movimientos</h1>
            <div className='self-end'>
                {/*<Button
                    className='buttonMain3'
                    icon='pi pi-plus'
                    iconPos='right'
                    label='Comprobante'
                />
                <Button
                    className='buttonMain3'
                    icon='pi pi-dollar'
                    iconPos='right'
                    label='Pagar'
                />
                <Button
                    className='buttonMain3'
                    icon='pi pi-download'
                    iconPos='right'
                />*/}
            </div>
            <CustomTable
                idTable='movementsTable'
                getItems={getMovements}
                params={{
                    movementStatus: selectedMovementStatus.length > 0 ? selectedMovementStatus.map(e => e.administrativeFormStateTypeI18n) : movementStatus.map(e => e.administrativeFormStateTypeI18n)
                }}
                showGridlines
                filterRow
                clearFiltersClassName='buttonClear'
                resizableColumns
                maxHeight={700}
            >
                <Column body={(e) => {
                    const movement = e
                    return <ButtonOverlay buttonClassName='button-grey p-button-rounded'>
                        <div className='flex flex-column'>
                            <TableButton label='Ver detalle' onClick={() => { }} className='text-left TableButtonStyle text-sm my-1 p-1' />
                            <TableButton label='Anular' onClick={() => { }} className='text-left TableButtonStyle text-sm my-1 p-1' />
                        </div>
                    </ButtonOverlay>
                }} />
                <Column field='invoicebusinessname' header='Razón social' filter filterElement={stringFilterTemplate} />
                <Column field='document' header='Cuit' filter filterElement={stringFilterTemplate} />
                <Column field='description' header='Tipo de comprobante' filter filterElement={stringFilterTemplate} />
                <Column field='formnumber' header='Nro comprobante' filter filterElement={stringFilterTemplate} />
                <Column field='date' header='Fecha' body={(e) => {
                    return new Date(e.date).toLocaleDateString()
                }}
                />
                <Column header='Estado' field='status' filter filterElement={<MultiSelect
                    options={movementStatus}
                    optionLabel='description'
                    onChange={(e) => setSelectedMovementStatus(e.value)}
                    value={selectedMovementStatus}
                    onTouchCancel={() => setSelectedMovementStatus([])}
                    className='text-info-slate'
                />} />
                <Column header='Importe' body={(e: Movement) => {
                    return formatCurrency(e.total)
                }} />
                <Column header='Pendiente' body={(e: Movement) => {
                    return formatCurrency(e.balance)
                }} />
            </CustomTable>
        </div>
    )
}

export default Movements
